import { FC, useState } from "react"
import Button from "@/components/Button"
import EmptyList from "@/components/EmptyList"
import SearchCriteriaCookieModal from "../SearchCriteriaCookieModal"
import type { SearchCriteriaAccessStatus } from "@/redux/services/searchCriteriaApi"

type Props = {
  status?: SearchCriteriaAccessStatus
}

const SearchCriteriaAccessBlock: FC<Props> = ({ status }: Props) => {
  const [openCookieModal, setOpenCookieModal] = useState(false)
  const cookieRequired =
    status?.enabled === true && status?.hasLinkedInCookie !== true
  const message = cookieRequired
    ? "Add your own LinkedIn cookie before using Search Criteria."
    : "Search Criteria access has not been enabled for your user. Ask a superadmin to enable it from the Users page."

  return (
    <>
      <div className="h-full min-h-[380px] bg-white rounded-md block-shadow flex justify-center items-center px-4">
        <EmptyList message={message}>
          {cookieRequired && (
            <Button onClick={() => setOpenCookieModal(true)} className="btn-sm">
              Add LinkedIn Cookie
            </Button>
          )}
        </EmptyList>
      </div>
      <SearchCriteriaCookieModal
        open={openCookieModal}
        onClose={() => setOpenCookieModal(false)}
      />
    </>
  )
}

export default SearchCriteriaAccessBlock
